<div (onHide)="onHide.emit(true)"  bsModal #modalBox="bs-modal"
  class="modal fade" tabindex="-1" role="dialog"
  aria-labelledby="mySmallModalLabel" aria-hidden="true" [config]="{backdrop: 'static', keyboard: false}">
  <div class="modal-dialog" [ngClass]="{'modal-sm': size =='small',
  'modal-md': size =='medium','modal-lg': size =='large',
  'modal-dialog-scrollable': scrollable, 'modal-dialog-centered': centered}" >
    <div class="modal-content">
      @if (showHeader) {
        <div class="modal-header">
          <h4 class="modal-title pull-left">
            <ng-content select="app-modal-header"></ng-content>
          </h4>
          <button type="button" class="btn-close" (click)="modalBox.hide()" aria-label="Close"></button>
        </div>
      }
      <div class="modal-body">
        <ng-content select="app-modal-body"></ng-content>
      </div>
      <div class="modal-footer">
        <ng-content select="app-modal-footer"></ng-content>
      </div>
    </div>
  </div>
</div>
